<template>
  <div class="fail">
    <div class="no-mic bord-btm text-center"  v-if="hardwareProblem">
      <p v-translate>We can't seem to find your microphone.</p>
    </div>
    <div class="mic-not-working bord-btm text-center" v-if="permissionProblem">
      <p v-translate>We have detected that you have a microphone installed but you haven't given us permission to use it.</p>
    </div>

    <div class="fix-this col-md-12 col-sm-12 col-xs-12 bord-btm pad-no">

      <h3 v-if="config.app === 'troubleshooter'" class="text-center" v-translate>Fix This</h3>
      <h4 v-if="config.app === 'virtualclassroom'" class="text-center" v-translate>Fix This</h4>

      <div v-if="permissionProblem">

        <div id="chrome-mic-enable" v-if="usersBrowserName === 'chrome' || usersBrowserName === 'Chrome'">
          <ul class="pad-lft col-md-6 col-sm-6 col-xs-6">
            <li>
              <translate>Click the</translate>&nbsp;<button class="btn btn-xs btn-default"><i class="fas fa-lock"></i>&nbsp;<translate>Secure</translate></button>&nbsp;<translate>button in the left-hand side of the address bar</translate>
            </li>
            <li>
              <translate>Click the dropdown across from the "Microphone" item in the list.</translate>
            </li>
            <li>
              <translate>Select "Allow" from the options in the dropdown</translate>
            </li>
            <li v-if="config.app === 'virtualclassroom'">
              <translate>Run the test again by clicking the</translate>&nbsp;<button class="btn btn-xs btn-info" v-translate>Redo Tests</button>&nbsp;<translate>Button below</translate>
            </li>
            <li v-if="config.app === 'troubleshooter'">
              <translate>Run the test again by clicking the</translate>&nbsp;<button class="btn btn-xs btn-danger" v-translate>Test Failed</button>&nbsp;<translate>Button above.</translate>
            </li>
          </ul>

          <div class=" col-md-6 col-sm-6 col-xs-6">
            <img class="center-block img-responsive thumbnail" alt="Unblock Chrome"
               :src="`${staticUrl}/images/troubleshooter/chrome-67-mic-unblock.jpg`">
          </div>

        </div>


        <div id="firefox-mic-enable" v-if="usersBrowserName === 'firefox' || usersBrowserName === 'Firefox'">
          <ul class="pad-lft col-md-6 col-sm-6 col-xs-6">
            <li>
              <translate>Click the</translate>&nbsp;<button class="btn btn-xs btn-default"><i class="fal fa-info-circle"></i>...<i class="fas fa-lock"></i></button>&nbsp;<translate>button in the left-hand side of the address bar</translate>
            </li>
            <li>
              <translate>In the "Permissions" section click the "X" beside the Microphone item to clear the settings</translate>
            </li>
          </ul>

          <div class=" col-md-6 col-sm-6 col-xs-6">
            <img class="center-block img-responsive thumbnail" alt="Unblock Firefox"
               :src="`${this.staticUrl}/images/troubleshooter/ff-61-mic-unblock-1.jpg`">
          </div>

          <ul class="pad-lft col-md-6 col-sm-6 col-xs-6">
            <li v-if="config.app === 'virtualclassroom'"><translate>Run the test again by clicking the</translate>&nbsp;<button class="btn btn-xs btn-info" v-translate>Redo Tests</button>&nbsp;<translate>Button below</translate></li>
            <li><translate>You will be prompted to allow permission for this website to access your microphone.</translate></li>
            <li><translate>Tick the box to "Remember this decision".</translate></li>
            <li><translate>Click "Allow".</translate></li>
          </ul>
          <div class=" col-md-6 col-sm-6 col-xs-6">
            <img class="center-block img-responsive thumbnail" alt="Unblock Firefox"
             :src="`${this.staticUrl}/images/troubleshooter/ff-61-mic-unblock-2.jpg`">
          </div>
        </div>

        <div id="opera-mic-enable" v-if="usersBrowserName === 'opera' || usersBrowserName === 'Opera'">

          <ul class="pad-lft  col-md-6 col-sm-6 col-xs-6">
            <li>
              <translate>Click the</translate>&nbsp;<button class="btn btn-xs btn-default"><i class="fa fa-video"></i></button>&nbsp;<translate>button in the left-hand side of the address bar</translate>
            </li>
            <li>
              <translate>Click the</translate>&nbsp;<button class="btn btn-xs btn-default" v-translate>Clear this Setting and Reload</button>&nbsp;<translate>button.</translate>
            </li>
          </ul>
          <div class=" col-md-6 col-sm-6 col-xs-6">
            <img class="center-block img-responsive thumbnail" alt="Unblock Firefox"
               :src="`${this.staticUrl}/images/troubleshooter/op-54-camera-unblock-1.jpg`">
          </div>

          <ul class="pad-lft col-md-6 col-sm-6 col-xs-6">
            <li><translate>The page will reload and you will be prompted to allow permission for this website to access your camera.</translate></li>
            <li><translate>Click "Allow".</translate></li>
          </ul>
          <div class=" col-md-6 col-sm-6 col-xs-6">
            <img class="center-block img-responsive thumbnail" alt="Unblock Opera"
               :src="`${this.staticUrl}/images/troubleshooter/op-54-mic-unblock-2.jpg`">
          </div>
        </div>

        <div id="safari-mic-enable" v-if="usersBrowserName === 'safari' || usersBrowserName === 'safari'">
            <ul class="pad-lft col-md-6 col-sm-6 col-xs-6">
              <li>
                <translate>Select Preferences in the main menu in the toolbar</translate>
              </li>
            </ul>
            <div class=" col-md-6 col-sm-6 col-xs-6">
              <img class="center-block img-responsive thumbnail" alt="Unblock Safari"
                 :src="`${this.staticUrl}/images/troubleshooter/safari-unblock1.png`">
            </div>

            <ul class="pad-lft col-md-6 col-sm-6 col-xs-6">
              <li>
                <translate>Select the websites tab</translate>
              </li>
              <li>
                <translate>Select the microphone icon</translate>
              </li>
              <li>
                <translate>Select allow in the dropdown</translate>
              </li>
              <li>
                <translate>Reload the page to allow the changes to be implemented</translate>
              </li>
              <li v-if="config.app === 'virtualclassroom'"><translate>Run the test again by clicking the</translate>&nbsp;<button class="btn btn-xs btn-info" v-translate>Redo Tests</button>&nbsp;<translate>Button below</translate></li>
            </ul>
            <div class=" col-md-6 col-sm-6 col-xs-6">
              <img class="center-block img-responsive thumbnail" alt="Unblock Safari"
                 :src="`${this.staticUrl}/images/troubleshooter/safari-unblock2.png`">
            </div>
        </div>
      </div>
      <div v-else>
        <p v-translate>You may need to re-install your camera / microphone software, drivers, or restart your device.</p>
      </div>

    </div>

    <div class="skip-test col-md-12 col-sm-12 col-xs-12">
        <h3 v-if="config.app === 'troubleshooter'" class="text-center" v-translate>Skip Test</h3>
        <h4 v-if="config.app === 'virtualclassroom'" class="text-center" v-translate>Skip Test</h4>

        <p class="text-left" v-translate>Skipping this test is not an option. Your teacher must be able to hear you for you to participate in the class.</p>

        <button class="btn btn-lg btn-warning disabled float-center" v-translate>Accept and Skip</button>
      </div>
  </div>
</template>

<script>
  /**
   * Microphone test fail explanation and solution
   */
  import TestFail from './TestFail.vue'
  import { staticUrl } from '@/../../shared/src/utils/constants'

  export default {
    name: 'MicrophoneFail',

    extends: TestFail,

    data () {
      return {
        'testName': 'microphone'
      }
    },

    props: {

      permissionProblem: {
        'type': Boolean,
        'default': true
      },

      hardwareProblem: {
        'type': Boolean,
        'default': false
      }
    }

  }
</script>

<style scoped lang="less">



</style>

<docs></docs>

